module.exports = __webpack_public_path__ + "media/images/landing_page/pakalpojumu_sniedzeji_mobile-42133f930d20c6bb258154d7a97b112d.png";